if (!customElements.get('compare-toggle')) {
  class CompareToggle extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('.compare-toggle__input');
      this.handle = this.dataset.handle;

      this.sync();

      this.onChange = this.onChange.bind(this);
      this.checkbox.addEventListener('change', this.onChange);
      this.unsubscribe = subscribe('compare:change', this.sync.bind(this));
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    onChange() {
      if (this.checkbox.checked) {
        if (isCompareFull()) {
          this.checkbox.checked = false;
          return;
        }

        addToCompare({
          handle: this.handle,
          title: this.dataset.title,
          image: this.dataset.image,
          price: this.dataset.price,
          url: this.dataset.url
        });
      } else {
        removeFromCompare(this.handle);
      }
    }

    sync() {
      var selected = isInCompare(this.handle);

      this.checkbox.checked = selected;
      this.checkbox.disabled = !selected && isCompareFull();
      this.checkbox.title = this.checkbox.disabled
        ? 'Fjern et produkt for å sammenligne et nytt'
        : '';
    }
  }

  customElements.define('compare-toggle', CompareToggle);
}
